@if (isUnified) {
  <!-- Unified Code: partners as the standard logo grid section (criterion 7 row 29), no autoplay. -->
  <section *ngIf="carouselResize.data.length" class="uc-home-section uc-partners" [dir]="isRtl ? 'rtl' : 'ltr'">
    <div class="container">
      <div class="uc-home-section__header">
        <h2 class="uc-home-section__title uc-display-sm" translate="home.partners"></h2>
      </div>
      <ul class="uc-partners__grid">
        <li *ngFor="let item of carouselResize.data; let i = index">
          <a *ngIf="item.url; else partnerLogo" class="uc-partners__tile" [href]="item.url" target="_blank" rel="noopener noreferrer"
            [attr.aria-label]="'unifiedHome.partner' | translate: { index: i + 1 }">
            <img loading="lazy" [src]="mediaUrl + item.imagePath" alt="">
          </a>
          <ng-template #partnerLogo>
            <span class="uc-partners__tile">
              <img loading="lazy" [src]="mediaUrl + item.imagePath" [alt]="'unifiedHome.partner' | translate: { index: i + 1 }">
            </span>
          </ng-template>
        </li>
      </ul>
    </div>
  </section>
} @else {
<section *ngIf="carouselResize.data.length">
  <div class="container py-5">
    <h2 class="home-titles mb-5" translate="home.partners" [class]="isRtl ? 'text-end' : 'text-start'"></h2>
    <app-custom-carousel #appCustomCarousel [content]="partnersContent" [carouselResize]="carouselResize" (shareIndex)="carouselResize.currentIndex = $event"></app-custom-carousel>
  </div>
  <ng-template #partnersContent>
    <div class="carousel-container w-100 position-relative overflow-hidden">
      <ng-container *ngFor="let slide of carouselResize.items; track i; let i = index">
        <div class="carousel-slide w-100 h-100 position-absolute" [ngStyle]="{left: 'calc('+ i +'*100%)', transform: 'translateX(-'+ carouselResize.currentIndex +'00%)'}">
          <div class="row h-100">
            <div class="col text-center h-100" *ngFor="let item of slide">
              <a [href]="item.url" target="_blank">
                <img [alt]="'unifiedHome.partner' | translate: { index: carouselResize.data.indexOf(item) + 1 }" loading="lazy" class="h-100" [src]="mediaUrl + item.imagePath">
              </a>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </ng-template>
</section>
}
